import React, { useState } from 'react';
import { Badge } from '../../ui/badge';
import { ChevronDown, ChevronUp } from 'lucide-react';
import UserStateItem from './UserStateItem';

const SECTION_TITLES = { user: 'USER INFO', payments_deposits: 'DEPOSITS', crypto_deposits: 'CRYPTO DEPOSITS', free_spins_all: 'FREE SPINS', bonuses: 'BONUSES', documents: 'DOCUMENTS' };

const UserStateSection = ({ title, data, type }) => {
  const [expanded, setExpanded] = useState(true);

  const formatTimestamp = (ts) => { if (!ts) return null; if (ts.seconds) return new Date(ts.seconds * 1000).toLocaleString(); return new Date(ts).toLocaleString(); };

  const renderUserContent = () => {
    if (!data || typeof data !== 'object') return null;
    return (
      <div className="space-y-2">
        {data.email && <div><span className="text-[10px] text-ink-dim block">Email</span><span className="text-sm">{data.email}</span></div>}
        {data.tags?.length > 0 && <div><span className="text-[10px] text-ink-dim block">Tags</span><div className="flex flex-wrap gap-1 mt-0.5">{data.tags.map((tag, i) => <Badge key={i} variant={tag.includes('DO NOT PAY') ? 'destructive' : tag.includes('ESCALATED') ? 'warning' : 'secondary'} className="text-[9px]">{tag}</Badge>)}</div></div>}
        <div><span className="text-[10px] text-ink-dim block">Deposited</span><span className="text-sm">{data.deposited ? 'Yes' : 'No'}</span></div>
        {data.created_at && <div><span className="text-[10px] text-ink-dim block">Created At</span><span className="text-sm">{formatTimestamp(data.created_at)}</span></div>}
        {data.last_sign_in_at && <div><span className="text-[10px] text-ink-dim block">Last Sign-In</span><span className="text-sm">{formatTimestamp(data.last_sign_in_at)}</span></div>}
        {data.last_sign_in_ip && <div><span className="text-[10px] text-ink-dim block">Last Sign-In IP</span><span className="text-sm">{data.last_sign_in_ip}</span></div>}
        {data.current_sign_in_country && <div><span className="text-[10px] text-ink-dim block">Country</span><span className="text-sm">{data.current_sign_in_country}</span></div>}
      </div>
    );
  };

  const count = type === 'user' ? null : Array.isArray(data) ? data.length : null;

  return (
    <div className="mb-3 border border-white/5 rounded-lg overflow-hidden">
      <div className="flex justify-between items-center p-2.5 cursor-pointer bg-white/[0.02] hover:bg-surface-2 transition-colors" onClick={() => setExpanded(!expanded)}>
        <span className="text-xs font-bold">{title || SECTION_TITLES[type] || type.toUpperCase()}{count !== null ? ` (${count})` : ''}</span>
        {expanded ? <ChevronUp className="h-4 w-4 text-ink-dim" /> : <ChevronDown className="h-4 w-4 text-ink-dim" />}
      </div>
      {expanded && (
        <div className="p-2.5">
          {type === 'user' ? renderUserContent() : Array.isArray(data) ? data.map((item, i) => <UserStateItem key={i} item={item} type={type} />) : null}
        </div>
      )}
    </div>
  );
};

export default UserStateSection;
